import ChildStatsRow from "../ChildStatsRow/ChildStatsRow";

import "./ClassStats.scss";

const ClassStats = ({ schoolChildren }) => {
  const StatsTableJSX = schoolChildren?.map((child) => (
    <ChildStatsRow child={child} key={child.uid} />
  ));

  return (
    <table className="class-stats">
      <thead>
        <tr>
          <th className="class-stats__header"></th>
          <th className="class-stats__header">Pupil Name</th>
          <th className="class-stats__header">Top Phonic</th>
          <th className="class-stats__header">Most Improved</th>
          <th className="class-stats__header">Needs Support</th>
          <th className="class-stats__header">Parent Name</th>
          <th className="class-stats__header">Parent Email</th>
          <th className="class-stats__header">Energy Level</th>
          <th className="class-stats__header">Recharge</th>
        </tr>
      </thead>
      {StatsTableJSX}
    </table>
  );
};
export default ClassStats;
